import React from 'react';
import { ShieldCheck } from 'lucide-react';

const ProTips = ({ tips, productName }) => {
  const list = Array.isArray(tips) && tips.length ? tips : null;
  if (!list) return null;
  return (
    <section className="mt-8" data-testid="pro-tips-section">
      <div className="flex items-center gap-2 mb-3">
        <ShieldCheck className="w-5 h-5 text-[#F46A25]" />
        <h2 className="text-lg md:text-xl font-black text-[#12263A]">Professional usage tips</h2>
      </div>
      <p className="text-xs text-neutral-500 mb-3">
        Insights from Dr Tools' trade team — how the professionals get the most out of {productName || 'this product'}.
      </p>
      <ol className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {list.map((tip, i) => (
          <li key={i} className="bg-white border-l-4 border-[#F46A25] border border-neutral-200 rounded-sm p-3" data-testid={`pro-tip-${i + 1}`}>
            <div className="text-[10px] uppercase tracking-widest font-bold text-[#F46A25] mb-1">Tip {i + 1}</div>
            <p className="text-sm text-[#12263A] leading-relaxed">{tip}</p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default ProTips;
